import React, { Component } from 'react';
import ErrorBox from './Error';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { authChannel } from '../utils/authSource';

// const REACT_APP_AUTH_ENV = process.env.REACT_APP_AUTH_ENV; // Removed: no longer used, removing to prevent linter warnings
export const KeycloakContext = React.createContext();

export const withAuthorization = WrappedComponent => {
    return class extends Component {
        static contextType = KeycloakContext;
        constructor(props) {
            super(props);
            this.state = { authenticated: undefined };
        }

        componentDidMount() {
            // Previously:
            // const keycloakPromise = this.context.keycloak.init({
            //     onLoad: 'login-required',
            //     promiseType: 'native', // removed promiseType - option is ignored since v9, promises are native anyway
            //     checkLoginIframe: REACT_APP_AUTH_ENV === 'local' ? false : true,
            // });
            //
            // Explanation of changes:
            // 1. Environment branching masked the issue. The flag was set so that locally the mechanism was disabled,
            //    but in all other environments it was enabled. That means in the only environment where the upgrade
            //    was tested manually, the critical path wasn't executed. After this fix, behavior will be the same everywhere.
            // 2. After this fix, session-iframe will not be present anywhere. The only lost functionality is auto-detection
            //    of external session changes (e.g. impersonate or admin logout). This auto-detection
            //    is no longer possible natively because the 3p-cookies check endpoint is missing in the new Keycloak version.
            //    We restored parity for this using a BroadcastChannel ('auth-success' and 'logout' messages).
            //    Token refresh via setInterval with updateToken does not depend on the iframe.
            const keycloakPromise = this.context.keycloak.init({
                onLoad: 'login-required',
                checkLoginIframe: false,
            });
            keycloakPromise
                .then(
                    authenticated => {
                        this.setState({ authenticated: authenticated });
                        // Broadcast 'auth-success' immediately after Keycloak initialization is complete.
                        // This allows other open tabs to instantly detect if the session was externally changed
                        // (e.g. admin impersonated a different user), serving as a workaround for the missing checkLoginIframe.
                        if (authenticated && typeof BroadcastChannel !== 'undefined' && this.context.keycloak.subject) {
                            const channel = new BroadcastChannel(authChannel);
                            channel.postMessage({ type: 'auth-success', subject: this.context.keycloak.subject });
                            channel.close();
                        }
                    },
                    error => {
                        this.setState({
                            authenticated: null,
                            error: error ? error : 'Failed to authenticate',
                        });
                    }
                )
                .catch(exception =>
                    this.setState({
                        authenticated: null,
                        error: exception
                            ? exception
                            : 'Failed to start authentication process',
                    })
                );
        }

        render() {
            if (this.state.authenticated) {
                return <WrappedComponent {...this.props} />;
            } else if (this.state.error) {
                return <ErrorBox message={this.state.error} />;
            }
            
            return <Box style={{position:'fixed',top:'50%',left:'50%', marginLeft:'-100px', marginTop:'-50px'}}><CircularProgress /><Typography> Loading ...</Typography> </Box>
        }
    };
};
